module.exports = __webpack_public_path__ + "img/portfolio-graphic-bg.4e94dbff.svg";